export const degToRad = (deg: number) => deg * (Math.PI / 180);

export const clamp01 = (v: number) => (v < 0 ? 0 : v > 1 ? 1 : v);

export const smoothstep = (edge0: number, edge1: number, x: number, eps: number = 0) => {
  const t = clamp01((x - edge0) / Math.max(eps, edge1 - edge0));
  return t * t * (3 - 2 * t);
};

export const smootherstep = (t: number): number => t * t * t * (t * (t * 6 - 15) + 10);

export const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const fract = (v: number): number => v - Math.floor(v);

export const hash1 = (x: number, seed: number): number => {
  let h = (x | 0) ^ (seed | 0);
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b);
  h = h ^ (h >>> 16);
  return h >>> 0;
};

export const hash2 = (x: number, y: number, seed: number): number => {
  let h = seed | 0;
  h ^= Math.imul(x | 0, 0x27d4eb2d);
  h ^= Math.imul(y | 0, 0x165667b1);
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b);
  h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35);
  h ^= h >>> 16;
  return h >>> 0;
};

export const hashToUnitFloat = (h: number): number => h / 0xffffffff;

export const hashToSignedFloat = (h: number): number => hashToUnitFloat(h) * 2 - 1;

export const remap = (
  value: number,
  inMin: number,
  inMax: number,
  outMin: number,
  outMax: number,
): number => {
  if (inMax === inMin) return outMin;
  const t = (value - inMin) / (inMax - inMin);
  return lerp(outMin, outMax, t);
};

export const contrast01 = (value: number, amount: number): number => {
  const centered = value - 0.5;
  const scaled = centered * (1 + amount);
  return clamp01(scaled + 0.5);
};

export const bias01 = (value: number, bias: number): number => {
  if (bias <= 0) return 1;
  if (bias >= 1) return 0;
  return value / ((((1 / bias) - 2) * (1 - value)) + 1);
};

export const gain01 = (value: number, gain: number): number => {
  if (value < 0.5) {
    return bias01(value * 2, gain) / 2;
  }
  return bias01(value * 2 - 1, 1 - gain) / 2 + 0.5;
};